<!--
 * @Author: ZhaoG
 * @Date: 2025-04-29 17:43:09
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-28 15:45:18
 * @FilePath: \gcp-fe\src\app\contactUs\views\operationGuide.vue
 * @Description: 操作指引
-->
<template>
  <div class="contactUs">
    <div class="contentMain">
      <base-bread-crumb
        class="bread-crumb"
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="true"
      ></base-bread-crumb>
    </div>
    <div class="mainBox">
      <div class="contentMain">
        <div class="title">操作指引</div>
        <p>
          中国交建电子采购平台--中交招采网是供应商及分包商加入中国交通建设集团有限公司(以下简称“中国交建”)合作商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与合作商建立积极的合作关系。
        </p>
        <p>
          中国交建对合作商实行准入管理，经准入的合作商具备参与中国交建及所属企业的线上投标和报价资格，凡有意参与中国交建采购业务的合作商均须认真阅读入网须知及注册指南，选择推荐单位注册《推荐单位为供应商信息的初审单位》，经审核通过后入网。
        </p>
        <div class="linkBox">
          <el-link
            type="primary"
            :href="pdfUrl"
            :underline="false"
            target="_blank"
            >中交招采网用户操作手册</el-link
          >
        </div>
        <div v-for="(item, index) in linkList" :key="index">
          <div class="titles">{{ item.title }}</div>
          <div
            class="linkBox"
            v-for="(item1, index1) in item.data"
            :key="index1"
          >
            <el-button
              type="text"
              v-if="item1.type === 1"
              @click="handleClick(item1)"
              size="mini"
              >{{ item1.title }}</el-button
            >
            <el-link
              type="primary"
              v-else
              :href="item1.url"
              :underline="false"
              target="_blank"
              >{{ item1.title }}</el-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from "../../noticesList/components/baseBreadCrumb";
export default {
  name: "announcement-list-revoked",
  components: {
    BaseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        {
          title: "操作指引"
        }
      ],
      pdfUrl:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100065/100002/default/202506/%E4%B8%AD%E4%BA%A4%E6%8B%9B%E9%87%87%E7%BD%91%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
      linkList: [
        {
          title: "供应商操作指南：",
          data: [
            {
              title: "1.入网须知",
              url: "/networkAccessNotice",
              type: 1
            },
            {
              title: "2.报名投标操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100065/100002/default/202506/%E4%BE%9B%E5%BA%94%E9%93%BE%E7%AE%A1%E7%90%86%E4%BF%A1%E6%81%AF%E7%B3%BB%E7%BB%9F--%E4%BE%9B%E5%BA%94%E5%95%86%E6%8A%A5%E5%90%8D%E6%8A%95%E6%A0%87%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
              type: 2
            },
            {
              title: "3.供应商操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100065/100002/default/202506/%E4%BE%9B%E5%BA%94%E9%93%BE%E7%B3%BB%E7%BB%9F%E9%87%87%E8%B4%AD%E5%AD%90%E5%B9%B3%E5%8F%B0-%E4%BE%9B%E5%BA%94%E5%95%86%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
              type: 2
            },
            {
              title: "4.供应商管控名单及黑名单申诉操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100069/117158/default/202509/%E4%BE%9B%E5%BA%94%E5%95%86%E7%AE%A1%E6%8E%A7%E5%90%8D%E5%8D%95%E5%8F%8A%E9%BB%91%E5%90%8D%E5%8D%95%E7%94%B3%E8%AF%89%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8Cv1.0.pdf",
              type: 2
            }
          ]
        },
        {
          title: "分包商操作指南：",
          data: [
            {
              title: "1.入库操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100065/100002/default/202506/%E4%B8%AD%E4%BA%A4%E9%9B%86%E5%9B%A2%E5%88%86%E5%8C%85%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E2%80%94%E5%88%86%E5%8C%85%E5%95%86%E5%85%A5%E5%BA%93.pdf",
              type: 2
            },
            {
              title: "2.入库操作视频",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202311/%E5%88%86%E5%8C%85%E5%95%86%E5%85%A5%E5%BA%93.mp4",
              type: 3
            },
            {
              title: "3.信息变更操作视频",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202311/%E4%BF%A1%E6%81%AF%E5%8F%98%E6%9B%B4~1.mp4",
              type: 3
            },
            {
              title: "4.投标操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100065/100002/default/202506/%E4%B8%AD%E4%BA%A4%E9%9B%86%E5%9B%A2%E5%88%86%E5%8C%85%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C-%E5%88%86%E5%8C%85%E5%95%86%E6%8A%95%E6%A0%87%EF%BC%8825%E5%B9%B4%EF%BC%89.pdf",
              type: 2
            },
            {
              title: "5.分包商管控名单及黑名单申诉操作手册",
              url:
                "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100069/117158/default/202509/%E5%88%86%E5%8C%85%E5%95%86%E7%AE%A1%E6%8E%A7%E5%90%8D%E5%8D%95%E5%8F%8A%E9%BB%91%E5%90%8D%E5%8D%95%E7%94%B3%E8%AF%89%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
              type: 2
            }
          ]
        }
      ]
    };
  },
  methods: {
    handleClick(item) {
      this.$router.push({
        path: item.url
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.contactUs {
  width: 100%;
  background: #eaeaea;

  .contentMain {
    width: 1180px;
    margin: 0 auto;
  }

  .mainBox {
    width: 100%;
    // height: 487px;
    padding-bottom: 30px;
    background: #fff;

    .title {
      width: 100%;
      padding: 20px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #4a4a4a;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 20px;
    }

    .titles {
      padding-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #4a4a4a;
    }

    p {
      // padding: 0 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      margin-bottom: 20px;
      text-indent: 2em;
    }
  }
}

.linkBox {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #0089ef;
  margin-top: 10px;
  /deep/ span {
    cursor: pointer;
    text-decoration-line: underline;
  }
  /deep/ .el-button--text {
    color: #0089ef;
    font-size: 13px;
  }
}

.bread-crumb {
  padding: 10px 0;
  margin: 0 !important;
}
</style>
